import Image from "next/image";

const CHART_FILL = "/assets-next/tools/previews/svg/bundle-chart-fill.svg";
const CHART_LINE = "/assets-next/tools/previews/svg/bundle-chart-line.svg";
const CHART_DOT = "/assets-next/tools/previews/svg/bundle-chart-dot.svg";

/**
 * Bundle pricing card inset (Figma 11097:39621 + header sibling on 11043:70436).
 * Chart fill/line/dot are SVG-only; tooltip copy is HTML.
 * Coords from Figma metadata, inset by 1px for the story canvas border box (241×179).
 */
export function BundlePricingPreview() {
  return (
    <div
      data-testid="bundle-pricing-canvas"
      className="relative h-full w-full overflow-hidden"
    >
      {/* Header — Figma 11097:39629 card-relative 22.336×18.295, −1px border inset */}
      <p className="text-grey-950 absolute top-[17.295px] left-[21.336px] text-[12px] leading-[1.4] font-normal whitespace-nowrap">
        Bundle price after discount
      </p>

      {/* Area fill — Figma 11097:39622 at 16×47.5 */}
      <Image
        src={CHART_FILL}
        alt=""
        width={220}
        height={79}
        aria-hidden
        className="pointer-events-none absolute top-[46.5px] left-[15px] h-[78.5px] w-[220px] max-w-none"
      />

      {/* Line stroke — Figma 11097:39623 at 16×47.114 */}
      <div
        aria-hidden
        className="pointer-events-none absolute top-[46.114px] left-[15px] h-[58.636px] w-[215px]"
      >
        <div className="absolute inset-[-0.85%_-0.23%]">
          <Image
            src={CHART_LINE}
            alt=""
            width={216}
            height={60}
            className="block size-full max-w-none"
          />
        </div>
      </div>

      {/* Tooltip — Figma 11097:39624 at 92.336×44.295 */}
      <div
        aria-hidden
        className="absolute top-[43.295px] left-[91.336px] h-[27px] w-[78px] rounded-[4px] bg-white shadow-[0_4.713px_9.426px_rgba(24,37,75,0.08)]"
      >
        <div className="absolute top-[4px] left-[8px] flex w-[75px] flex-col leading-[1.5]">
          <p
            className="text-[5px] tracking-[-0.1px] text-black/50"
            style={{
              fontFeatureSettings: '"ss03" 1, "ss01" 1, "zero" 1, "ss02" 1',
            }}
          >
            Discount bundle up to 33%
          </p>
          <p
            className="text-[8px] tracking-[-0.16px] text-[#1574cd]"
            style={{
              fontFeatureSettings: '"ss03" 1, "ss01" 1, "zero" 1, "ss02" 1',
            }}
          >
            $33.50
          </p>
        </div>
      </div>

      {/* Marker dot — Figma 11097:39628 at 185×61 */}
      <Image
        src={CHART_DOT}
        alt=""
        width={7}
        height={7}
        aria-hidden
        className="pointer-events-none absolute top-[60px] left-[184px] size-[7px] max-w-none"
      />
    </div>
  );
}
